<template>
	<div class="docs-landing-page-root" style="width: 100%; height: 100vh; display: flex; flex-direction: column; margin: 0; padding: 0; background-color: #fff;">
		
		<!-- Custom Documentation Header -->
		<div
			style="display: flex; justify-content: space-between; align-items: center; padding: 0 20px; height: 60px; border-bottom: 1px solid #ebeef5; background-color: #fff; flex-shrink: 0; position: relative; z-index: 1001;">
			<div style="display: flex; align-items: center;">
				<div style="display: flex; align-items: center; gap: 10px; cursor: pointer;" @click="$router.push('/')">
					<img src="../assets/primaryLogo.svg" style="height: 28px; object-fit: contain;" />
					<span style="font-size: 16px; font-weight: 600; color: #1f2d3d; margin-left: 5px;" class="hide-on-mobile">Documentation</span>
				</div>
			</div>
			<div style="display: flex; align-items: center; gap: 10px;">
				<el-autocomplete
					clearable
					placeholder="Search integrations"
					prefix-icon="el-icon-search"
					v-model="integrationSearchQuery"
					:fetch-suggestions="querySearch"
					@select="handleSearchSelect"
					style="max-width: 250px; width: 100%;"
					size="small"
					class="docs-search"
					value-key="displayName"
				></el-autocomplete>
			</div>
		</div>

		<!-- Main Centered Content -->
		<div class="docs-landing-page">
			<div class="container">
				<img class="hero-img" src="/authentication.svg" alt="Authentication" />
				<h1>Documentation Explorer</h1>
				<p>Welcome to the Centiloquy documentation. This site will help you explore and understand all features, configurations, and integrations within Centiloquy.</p>
				<el-button type="primary" class="btn" @click="goToDocs">View Documentation</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "DocsPage",
    data() {
        return {
            integrationSearchQuery: "",
            availableIntegrations: [],
        };
    },
    async mounted() {
        await this.returnAllNodes();
    },
    methods: {
        goToDocs() {
            this.$router.push('/docs/documentation');
        },
        async returnAllNodes() {
            const result = await this.httpHelper("RUNTIME", "GET", "nodes/returnAllNodeDefinitions", {});
            if (!result?.error) {
                const internalOnly = ["aiIntegrationSandbox", "aiWorkflowTemplate"];
                const filtered = (result.response || []).filter(item => !internalOnly.includes(item.nodesObjectPropertyName));
                this.availableIntegrations = Object.freeze(filtered);
            }
        },
        querySearch(queryString, cb) {
            const internalOnly = ["aiIntegrationSandbox", "aiWorkflowTemplate"];
            const links = (this.availableIntegrations || []).filter(integration => !internalOnly.includes(integration.nodesObjectPropertyName));
            const results = queryString ? links.filter(integration => integration.displayName.toLowerCase().includes(queryString.toLowerCase())) : links;
            cb(results);
        },
        handleSearchSelect(item) {
            this.$router.push({ path: '/docs/documentation', query: { integration: item.nodesObjectPropertyName } });
        }
    }
}
</script>

<style scoped>
.docs-landing-page {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex: 1;
    margin: 0;
    background-color: #ffffff;
    color: #333;
}
.container {
    text-align: center;
    max-width: 700px;
    padding: 20px;
}
.hero-img {
    max-width: 350px;
    margin: 0 auto 2rem auto;
    display: block;
}
h1 {
    color: #1a1a4b;
    font-size: 2.8rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
}
p {
    font-size: 1.25rem;
    line-height: 1.7;
    color: #7a7a9a;
    margin-bottom: 2.5rem;
    padding: 0 20px;
}
.btn {
    background-color: #fc7474 !important;
    border-color: #fc7474 !important;
    color: white !important;
    padding: 14px 35px;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 600;
    font-size: 1.1rem;
    transition: background-color 0.3s;
}
.btn:hover {
    background-color: #f75d5d !important;
    border-color: #f75d5d !important;
}
@media (max-width: 768px) {
	.hide-on-mobile {
		display: none;
	}
}
</style>
